(() => {
  const moneyFromNumber = (value) => {
    const numeric = Number(value || 0);
    return `$${numeric.toLocaleString('es-CO')}`;
  };

  document.querySelectorAll('[data-ticket-dock]').forEach((dock) => {
    const section = dock.closest('[data-section-id]');
    if (!section) return;

    const tickets = Array.from(section.querySelectorAll('[data-ticket-option]'));
    const variantInput = dock.querySelector('[data-ticket-variant-input]');
    const quantityInput = dock.querySelector('[data-ticket-quantity]');
    const titleEl = dock.querySelector('[data-ticket-dock-title]');
    const descriptionEl = dock.querySelector('[data-ticket-dock-description]');
    const priceEl = dock.querySelector('[data-ticket-dock-price]');
    const subtotalEl = dock.querySelector('[data-ticket-subtotal]');
    const colorEl = dock.querySelector('[data-ticket-dock-color]');
    const iconEl = dock.querySelector('[data-ticket-dock-icon]');
    const submitButton = dock.querySelector('[type="submit"]');
    const minusButton = dock.querySelector('[data-ticket-qty-minus]');
    const plusButton = dock.querySelector('[data-ticket-qty-plus]');
    const codAckInput = section.querySelector('[data-ticket-cod-ack]');

    if (!tickets.length || !variantInput || !quantityInput || !submitButton) return;

    const getSelectedTicket = () =>
      tickets.find((ticket) => ticket.classList.contains('is-selected')) || tickets.find((ticket) => ticket.dataset.available === 'true') || tickets[0];

    const updateSubtotal = () => {
      const selected = getSelectedTicket();
      const quantity = Math.max(1, Number(quantityInput.value || 1));
      const cents = Number(selected?.dataset.priceCents || 0);
      if (Number.isFinite(cents) && cents > 0) {
        subtotalEl.textContent = moneyFromNumber((cents / 100) * quantity);
      } else {
        subtotalEl.textContent = selected?.dataset.price || '';
      }
    };

    const selectTicket = (ticket) => {
      if (!ticket || ticket.dataset.available !== 'true') return;

      tickets.forEach((item) => {
        item.classList.toggle('is-selected', item === ticket);
        const button = item.querySelector('[data-ticket-select]');
        if (button) button.setAttribute('aria-pressed', item === ticket ? 'true' : 'false');
      });

      variantInput.value = ticket.dataset.variantId;
      variantInput.disabled = false;
      titleEl.textContent = ticket.dataset.title;
      descriptionEl.textContent = ticket.dataset.description;
      priceEl.textContent = ticket.dataset.price;

      if (colorEl) {
        colorEl.className = `owl-event-buy__icon owl-event-buy__icon--${ticket.dataset.color || 'green'}`;
      }

      if (iconEl && ticket.dataset.iconUrl) {
        iconEl.src = ticket.dataset.iconUrl;
      }

      dock.classList.remove('owl-event-buy--green', 'owl-event-buy--cyan', 'owl-event-buy--purple', 'owl-event-buy--red');
      dock.classList.add(`owl-event-buy--${ticket.dataset.color || 'green'}`);

      updateSubtotal();
      updateSubmitState();
    };

    function updateSubmitState() {
      const selected = getSelectedTicket();
      const available = selected?.dataset.available === 'true';
      const ackOk = !codAckInput || codAckInput.checked;
      const enabled = available && ackOk;
      submitButton.disabled = !enabled;
      if (enabled) {
        submitButton.removeAttribute('aria-disabled');
      } else {
        submitButton.setAttribute('aria-disabled', 'true');
      }
    }

    codAckInput?.addEventListener('change', updateSubmitState);

    tickets.forEach((ticket) => {
      const button = ticket.querySelector('[data-ticket-select]');
      if (!button) return;
      button.addEventListener('click', () => selectTicket(ticket));
    });

    quantityInput.addEventListener('input', () => {
      if (Number(quantityInput.value || 0) < 1) quantityInput.value = 1;
      updateSubtotal();
    });

    minusButton?.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
      updateSubtotal();
    });

    plusButton?.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1);
      updateSubtotal();
    });

    selectTicket(getSelectedTicket());
  });
})();
